import React, {useEffect, useState} from 'react';
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import Button from "react-bootstrap/Button";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import DVTJCUVSearchCddJobChooseReceiverModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobChooseReceiverModal";
import DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList";

const DVTJCUVEmpCareBriefUVTabContent = (props) => {
    // const [pipelineList, setPipelineList] = useState([]);

    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});

    const {cddId, parentTab, subTab} = props

    // const fetchPipeLines = async (pTab, sTab, sorts) => {
    //     const params = {
    //         search_conditions: {
    //             parent_tab: pTab?.id,
    //             sub_tab: sTab?.id,
    //             cdd_id: cddId,
    //             unlimited: true
    //         },
    //         sort_columns: sorts
    //     }
    //
    //     const res = await requestGetDVTJCUVPipeLineList(params);
    //     const resContent = res.content
    //     setPipelineList(resContent.pipelines)
    //
    // }

    useEffect(() => {
        setParentOfTab(parentOfTab)
    }, [parentTab]);

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{parentTab.title}</h3>
                    <div className={'card-tools'}>
                    </div>
                </div>
                <div className='card-body'>
                    {/*<DVTJCUVPipelineTableList*/}
                    {/*    pipeLines={pipelineList}*/}
                    {/*    mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}*/}
                    {/*    parentTabId={DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id}*/}
                    {/*    subTabId={subTab.id}*/}
                    {/*/>*/}
                    <DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList
                        cddId={cddId}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
                        parentTab={DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB}
                        startFetching={!!parentTab.id}
                    />
                </div>
            </div>
        </>
    )
}
export default DVTJCUVEmpCareBriefUVTabContent;
